import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/faqs";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const {
    mainPrice
  } = useLocalizedPrices();
  return <section id="preguntas" className="bg-cream-50 py-14 sm:py-28" data-id="element-92" data-mp="1glgegz78ewgq">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-93" data-mp="249pv7mpl8u10">
        <div data-id="element-94" data-mp="289hxxisaw5yg">
          <h2 className="font-display text-4xl font-semibold leading-tight text-cocoa-900 sm:text-5xl" data-id="element-95" data-mp="289zygrlzx6c6">Preguntas frecuentes</h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-700" data-id="element-96" data-mp="1zihlsqo9d8nu">Todo lo que necesitas saber antes de empezar, con respuestas honestas.</p>
        </div>

        <ul className="border-t border-cocoa-900/10" data-id="element-97" data-mp="2n6hazm5x8r0b">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="border-b border-cocoa-900/10" data-id="element-98" data-mp="14v0u0xhr5w7r" data-mpi={i}>
                <h3 data-id="element-99" data-mp="14t7mzh3899z8">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-semibold text-cocoa-900 focus:outline-none focus-visible:text-caramel-600" data-id="element-100" data-mp="10toy6a8acer4">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-caramel-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-101" data-mp="1jjeuj1rp58l5" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-102" data-mp="3556k8rd9luu">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-103" data-mp="3uchowr3zk5cc">
                      <p className="pb-6 pr-10 leading-relaxed text-cocoa-700" data-id="element-104" data-mp="2c8mh6l4aj1b1">{f.a.replace("{precio}", mainPrice)}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}